<template>
  <div class="mask" :class="{ 'mask-hidden': bgc === 'false' }">
    <div class="loading">
      <div class="loading-icon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    bgc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="sass">
@import "../../sass/base/_abbrev.scss";

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 10000;

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    width: rem(120);
    height: rem(120);
    border-radius: rem(10);
    background-color: rgba(0, 0, 0, .6);
    transform: translate(-50%, -50%);
  }

  .loading-icon{
    width: rem(50);
    height: rem(50);
    background-image: url("../../img/common/loading.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    animation: circle .5s infinite linear;
    margin: rem(36) auto;
  }
}
.mask-hidden {
  background-color: rgba(0, 0, 0, 0);
}
@keyframes circle {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// loading.vue?19dc808a